/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TestExpressionVariableDto } from './TestExpressionVariableDto';
import {
    TestExpressionVariableDtoFromJSON,
    TestExpressionVariableDtoFromJSONTyped,
    TestExpressionVariableDtoToJSON,
    TestExpressionVariableDtoToJSONTyped,
} from './TestExpressionVariableDto';

/**
 * Test à blanc d'une formule de tarification avec des valeurs d'essai. Rien n'est enregistré.
 * @export
 * @interface TestExpressionCommand
 */
export interface TestExpressionCommand {
    /**
     * 
     * @type {string}
     * @memberof TestExpressionCommand
     */
    expression: string;
    /**
     * 
     * @type {Array<TestExpressionVariableDto>}
     * @memberof TestExpressionCommand
     */
    variables?: Array<TestExpressionVariableDto>;
}

/**
 * Check if a given object implements the TestExpressionCommand interface.
 */
export function instanceOfTestExpressionCommand(value: object): value is TestExpressionCommand {
    if (!('expression' in value) || value['expression'] === undefined) return false;
    return true;
}

export function TestExpressionCommandFromJSON(json: any): TestExpressionCommand {
    return TestExpressionCommandFromJSONTyped(json, false);
}

export function TestExpressionCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestExpressionCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'expression': json['expression'],
        'variables': json['variables'] == null ? undefined : ((json['variables'] as Array<any>).map(TestExpressionVariableDtoFromJSON)),
    };
}

export function TestExpressionCommandToJSON(json: any): TestExpressionCommand {
    return TestExpressionCommandToJSONTyped(json, false);
}

export function TestExpressionCommandToJSONTyped(value?: TestExpressionCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expression': value['expression'],
        'variables': value['variables'] == null ? undefined : ((value['variables'] as Array<any>).map(TestExpressionVariableDtoToJSON)),
    };
}

